"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allowedLanguages = exports.Language = void 0;
exports.languageToLabel = languageToLabel;
exports.languageToLocale = languageToLocale;
exports.localeToLanguage = localeToLanguage;
var Language;
(function (Language) {
  Language["English"] = "English";
  Language["Spanish"] = "Spanish";
  Language["French"] = "French";
})(Language || (exports.Language = Language = {}));
const allowedLanguages = exports.allowedLanguages = Object.values(Language);
function languageToLocale(language) {
  switch (language) {
    case 'French':
      return 'fr';
    case 'Spanish':
      return 'es';
    default:
      return 'en';
  }
}
function localeToLanguage(locale) {
  switch (locale) {
    case 'es':
    case 'es-MX':
      return 'Spanish';
    case 'fr':
    case 'fr-CA':
      return 'French';
    default:
      return 'English';
  }
}
function languageToLabel(language) {
  switch (language) {
    case 'French':
      return 'Français';
    case 'Spanish':
      return 'Español';
    default:
      return 'English';
  }
}